import React, { Component, Fragment } from "react";

import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AxlButton, AxlModal } from "axl-reactjs-ui";
import { isEmpty, pick } from 'lodash';
import { inject, observer } from "mobx-react";
import Moment from "react-moment";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";

import AxlDialog from '../../AxlDialog';
import AxlMuiButton from "../../AxlMuiButton";
import Button from "../../JMuiButton";

// Styles
import { checkDuplicates } from "../../../stores/api";
import {
  Col, ColDropTime, Container, Label, Row, RowCenter, RowHeader, Text, TextError, Title,
} from "./styles";
import { colors } from "../../../themes/colors";

export const KEY_DUPLICATED = {
  TRACKING_CODE: 'tracking_code',
  CLIENT_INTERNAL_SHIPMENT_ID: 'client_internal_shipment_id',
  CLIENT_INTERNAL_SHIPMENT_ID_TRACKING_CODE: 'client_internal_shipment_id,tracking_code',
  ORDER_ID: 'order_id',
}

@inject("jobStore", "userStore")
@observer
class ShipmentUploadDetailPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDownloadBox: false,
      openConfirmModal: false,
      isOpenConfirmDuplicate: false,
      isResolving: false,
      isCheckingDuplicates: false,
      dataDuplicates: {},
      expanded: false,
    };
  }

  deleteJob = (e) => {
    const { jobStore } = this.props;
    if (!jobStore.selectedJob) return;
    jobStore.deleteDraftJob(jobStore.selectedJob.id, () => {
      this.props.history.push("/batch");
      this.setState({ 
        openConfirmModal: false,
      });
    });
  };

  finalizeJob = (e) => {
    const { jobStore } = this.props;
    if (!jobStore.selectedJob) return;
    jobStore.finalizeDraftJob(jobStore.selectedJob.id, (res) => {
      if(!res.ok) {
        toast.error(res?.data?.message || 'Something went wrong!');
        return;
      }
      jobStore.selectedJob = res.data;
      this.props.history.replace(`/batch/${res.data.id}`);
      jobStore.getShipments();
      toast.success("Finalize successfully!");
    });
  };

  handleCheckingDuplicate = (val) => {
    if(!val && this.state.isResolving) return;
    
    this.setState({
      isOpenConfirmDuplicate: val,
      isCheckingDuplicates: val,
      dataDuplicates: {},
    })

    if(val) {
      const { jobStore } = this.props;
      checkDuplicates(jobStore?.selectedJob?.id)
        .then(res => {
          if (res.ok) {
            this.setState({dataDuplicates: res.data})
          }
        })
        .finally(() => {this.setState({isCheckingDuplicates: false})})
    }
  }

  handleResolve = () => {
    this.setState({isResolving: true});

    const { jobStore } = this.props;
    jobStore.handleResolveDuplicates(jobStore?.selectedJob?.id, res => {
      if (!res.ok) {
        this.setState({isResolving: false});
        toast.error('Resolve duplicated fail');
        return;
      }
      else {
        const { dataDuplicates } = this.state;
        this.setState({
          dataDuplicates: {
            ...dataDuplicates,
            total_removed: 0,
          },
          isOpenConfirmDuplicate: false,
          isResolving: false,
        }, () => {
          jobStore.selectedJob = res.data
        });
        toast.success('Resolve duplicated successfully');
        if (jobStore?.selectedShipment) {
          jobStore.selectedShipment = null;
          this.props.history.replace(`/batch/${jobStore?.selectedJob?.id}`);
        }
      }
    })
  }

  openDownloadBox = (e) => this.setState({ openDownloadBox: true });
  closeDownloadBox = (e) => this.setState({ openDownloadBox: false });

  handleChangeAccordion = (panel) => (event, isExpanded) => {
    this.setState({expanded: isExpanded ? panel : false});
  };

  transformKey = (k) => {
    switch (k) {
      case KEY_DUPLICATED.TRACKING_CODE:
        return 'Duplicated Tracking Codes';

      case KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID:
        return 'Duplicated Internal IDs';

      case KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID_TRACKING_CODE:
        return 'Duplicated Internal IDs and Tracking Codes';
    
      default:
        return "";
    }
  }

  getShipmentDuplicated = (data, k) => {
    switch (k) {
      case KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID_TRACKING_CODE:
        const tempData = data?.[`list_duplicated-${k}`];
        const content = <>
          <span style={{display: 'block'}}>
            <b>{this.transformKey(KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID)}</b>: {tempData?.[KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID]?.join(", ")}
          </span>
          <span style={{display: 'block'}}>
            <b>{this.transformKey(KEY_DUPLICATED.TRACKING_CODE)}</b>: {tempData?.[KEY_DUPLICATED.TRACKING_CODE]?.join(", ")}
          </span>
        </>
        return content;

      default:
        return data?.[`list_duplicated-${k}`]?.join(", ");
    }
  }

  render() {
    const { openConfirmModal, isOpenConfirmDuplicate, isResolving, isCheckingDuplicates, dataDuplicates, expanded } = this.state;
    const { jobStore, isBlur, userStore } = this.props;
    const { selectedJob, deletingJob, finalizing, duplicatedShipments, loadingShipments, erroredShipments } = jobStore;
    const canResolveDuplicated = userStore?.clientSettings?.validation_settings?.csv_resolve_duplicated;

    if (!selectedJob) return null;

    const isError = !!selectedJob.error_count && selectedJob.error_count > 0;
    const isDraftJob =
      selectedJob.status && jobStore.isDraftJob(selectedJob.status);

    return (
      <Container
        style={{ ...this.props.style, ...{ paddingBottom: isError ? 37 : 15 } }}
      >
        <RowHeader>
          <Col>
            <Title>{selectedJob.name}</Title>
          </Col>
          {isDraftJob && (
            <AxlMuiButton
              onClick={() => this.setState({ openConfirmModal: true })}
              style={{backgroundColor: 'red'}}
              label={'DELETE JOB'}
            />
          )}
        </RowHeader>
        <Row>
          <div>
            <Label>{`Total Shipments`.toUpperCase()}</Label>
            <Text
              className={`${isBlur ? "text-blur" : ""}`}
            >{`${selectedJob.shipment_count}`}</Text>
          </div>
          <ColDropTime>
            <Label>{`Earliest Dropoff Time`.toUpperCase()}</Label>
            <Text className={`${isBlur ? "text-blur" : ""}`}>
              <Moment interval={0} format={"MM/DD/YYYY @ HH:mm:ss"}>
                {selectedJob.dropoff_earliest_ts}
              </Moment>
            </Text>
          </ColDropTime>
          <div>
            <Label>{`Status`.toUpperCase()}</Label>
            <Text className={`${isBlur ? "text-blur" : ""}`}>
              {selectedJob.status}
            </Text>
          </div>
        </Row>
        <RowCenter>
          <Col>
            {selectedJob.csv_url && (
              <a href={selectedJob.csv_url}>
                <AxlButton compact bg={`whiteBorLightGrey`}>{`CSV`}</AxlButton>
              </a>
            )}
          </Col>
          {!loadingShipments && duplicatedShipments?.length > 0 && canResolveDuplicated && (
            <AxlMuiButton
              onClick={() => this.handleCheckingDuplicate(true)}
              style={{backgroundColor: colors.lightOrange}}
              disabled={duplicatedShipments?.length < 1}
              label={'Resolve Duplicates'}
            />
          )}
          {((selectedJob?.error_count === 0 && erroredShipments?.length === 0) && jobStore?.selectedJobShipments?.length > 0 && jobStore.isDraftJob(selectedJob.status)) && (
            <Button
              loading={finalizing}
              onClick={this.finalizeJob}
              variant="contained"
              color="primary"
              disabled={selectedJob.error_count && selectedJob.error_count > 0}
            >{`Finalize`}</Button>
          )}
          {selectedJob.label_pdf_url &&
            !(selectedJob.resources && selectedJob.resources.length > 0) && (
              <a href={selectedJob.label_pdf_url}>
                <AxlButton compact>{`Download Labels`}</AxlButton>
              </a>
            )}
          {selectedJob.resources && selectedJob.resources.length > 0 && (
            <a href="javascript:void(0)">
              <AxlButton
                onClick={this.openDownloadBox}
                compact
              >{`Download Labels`}</AxlButton>
            </a>
          )}
        </RowCenter>
        {!!selectedJob.error_count && selectedJob.error_count > 0 && (
          <TextError>{`Please resolve error or duplicates before finalizing.`}</TextError>
        )}
        {selectedJob.resources &&
          selectedJob.resources.length > 0 &&
          this.state.openDownloadBox && (
            <AxlModal onClose={this.closeDownloadBox}>
              {selectedJob.resources.map((resource) => (
                <a href={resource.pdf_url} target="_blank" rel="noopener">
                  <AxlButton compact>
                    {resource.title
                      ? `Download ${resource.title}`
                      : `Download Labels`}
                  </AxlButton>
                </a>
              ))}
            </AxlModal>
          )}
        {openConfirmModal && (
          <AxlDialog
            isOpen={openConfirmModal}
            handleClose={() => this.setState({ openConfirmModal: false })}
            childrenTitle={'DELETE JOB'}
            children={'Are you sure to delete this job? This cannot be undone.'}
            maxWidth="xs"
            childrenAction={
              <Box>
                <AxlMuiButton
                  onClick={() => this.setState({ openConfirmModal: false })}
                  label={'Cancel'}
                  variant="outlined"
                  style={{marginRight: 8, backgroundColor: '#fff', color: '#000'}}
                />
                <AxlMuiButton
                  onClick={this.deleteJob}
                  disabled={deletingJob}
                  style={{ backgroundColor: 'red' }}
                  label={deletingJob ? <CircularProgress size={20} color="#fff" /> : 'Delete'}
                />
              </Box>
            }
          />
        )}

        {isOpenConfirmDuplicate && (
          <AxlDialog
            isOpen={isOpenConfirmDuplicate}
            maxWidth="sm"
            childrenTitle={"Confirmation"}
            handleClose={() => this.handleCheckingDuplicate(false)}
            children={<Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
              {isCheckingDuplicates && (
                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                  <Box mb={2}>Checking shipment data. Please wait...</Box>
                  <CircularProgress size={20}/>
                </Box>
              )}
              {isEmpty(dataDuplicates) && !isCheckingDuplicates && `Your csv is good to process`}
              {!isEmpty(dataDuplicates) && !isCheckingDuplicates && dataDuplicates?.total_removed === selectedJob?.shipment_count && `All shipments in this CSV are duplicated, we cannot resolve in this case`}
              {!isEmpty(dataDuplicates) && !isCheckingDuplicates && dataDuplicates?.total_removed < selectedJob?.shipment_count && (
                <Box fontFamily={'AvenirNext'} width={'100%'}>
                  <Box mb={2} textAlign={'center'} fontWeight={600}>Duplicated shipment info</Box>
                  {Object.entries(pick(dataDuplicates, [KEY_DUPLICATED.TRACKING_CODE, KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID, KEY_DUPLICATED.CLIENT_INTERNAL_SHIPMENT_ID_TRACKING_CODE]))?.map(([k, v]) => {
                    if(isEmpty(dataDuplicates?.[`list_duplicated-${k}`])) return null;
                    
                    return (
                      <Accordion expanded={expanded === k} onChange={this.handleChangeAccordion(k)} key={k}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                            <Typography>{this.transformKey(k)}</Typography>
                            <Typography style={{fontWeight: 500}}>{v} rows</Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            {this.getShipmentDuplicated(dataDuplicates, k)}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    )
                  })}

                  <Box mt={2} display={'flex'} alignItems={'end'} flexDirection={'column'}>
                    <Box>In CSV: {selectedJob?.shipment_count || 0} shipments</Box>
                    <Box>Will be removed: <span style={{color: 'red'}}>{dataDuplicates?.total_removed || 0}</span> shipments</Box>
                    <Box>After resolve: <b>{selectedJob?.shipment_count - dataDuplicates?.total_removed || 0}</b> shipments</Box>
                  </Box>
                </Box>
              )}
            </Box>}
            childrenAction={
              <Box display='flex' justifyContent='flex-end'>
                <AxlMuiButton
                  onClick={() => this.handleCheckingDuplicate(false)}
                  disabled={isResolving}
                  label="Cancel"
                  variant="outlined"
                  style={{marginRight: 8, backgroundColor: '#fff', color: '#000'}}
                />
                {dataDuplicates?.total_removed < selectedJob?.shipment_count && (
                  <Button 
                    onClick={this.handleResolve} 
                    variant='contained' color='primary' 
                    disabled={isResolving || isCheckingDuplicates || isEmpty(dataDuplicates)} 
                    size="small" loading={isResolving}>
                    Resolve
                  </Button>
                )}

                {dataDuplicates?.total_removed === selectedJob?.shipment_count && (
                  <AxlMuiButton 
                    onClick={() => this.setState({ openConfirmModal: true })} 
                    style={{backgroundColor: 'red'}}
                    label="DELETE JOB"
                  />
                )}
              </Box>
            }
          />
        )}
      </Container>
    );
  }
}

export default withRouter(ShipmentUploadDetailPanel);
